import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Image from 'gatsby-image'
import { rhythm } from '../../utils/typography'
import NavBar from '../../components/navbar'

import './index.scss'

const Portfolio = () => {
  const data = useStaticQuery(graphql`
    query integrifyImage {
      integrify: file(absolutePath: { regex: "/integrify.png/" }) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      rens: file(absolutePath: { regex: "/rens.png/" }) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      survey: file(absolutePath: { regex: "/survey.png/" }) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      cv: file(absolutePath: { regex: "/portfolio.png/" }) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <div className="portfolio">
      <NavBar />
      <p style={{ color: '#ffa7c4' }} className="title">
        Projects that I have build as hobby projects or have been part of...
      </p>

      <div className="work">
        <div className="portfolio__integrify">
          <Image
            fluid={data.integrify.childImageSharp.fluid}
            alt="integrify website"
            style={{
              marginRight: rhythm(1 / 2),
              marginBottom: 0,
              cursor: 'pointer'
            }}
            className="integrify_work"
          />
          <Link to="/work/integrify">
            <div className="fadedbox">
              <div className="title text"> Click Here For Details </div>
            </div>
          </Link>
        </div>
        <div className="portfolio__rens">
          <Image
            fluid={data.rens.childImageSharp.fluid}
            alt="rens website"
            style={{
              marginRight: rhythm(1 / 2),
              marginBottom: 0,
              cursor: 'pointer'
            }}
            className="rens_work"
          />
          <Link to="/work/rens">
            <div className="fadedbox">
              <div className="title text"> Click Here For Details </div>
            </div>
          </Link>
        </div>
        <div className="portfolio__survey">
          <Image
            fluid={data.survey.childImageSharp.fluid}
            alt="indiegogo survey form"
            style={{
              marginRight: rhythm(1 / 2),
              marginBottom: 0,
              cursor: 'pointer'
            }}
            className="survey_work"
          />
          <Link to="/work/survey">
            <div className="fadedbox">
              <div className="title text"> Click Here For Details </div>
            </div>
          </Link>
        </div>
        <div className="portfolio__cv">
          <Image
            fluid={data.cv.childImageSharp.fluid}
            alt="aditya gyawali portfolio"
            style={{
              marginRight: rhythm(1 / 2),
              marginBottom: 0,
              cursor: 'pointer'
            }}
            className="cv_work"
          />
          <Link to="/work/portfolio">
            <div className="fadedbox">
              <div className="title text"> Click Here For Details </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}
export default Portfolio
